import { z } from 'zod';
import { positiveDecimalSchema, currencyCodeSchema, isoDateSchema, uuidSchema } from './common';

export const debtDirectionSchema = z.enum(['owed_to_me', 'i_owe']);
export type DebtDirection = z.infer<typeof debtDirectionSchema>;

export const debtStatusSchema = z.enum(['open', 'partially_paid', 'paid', 'cancelled']);
export type DebtStatus = z.infer<typeof debtStatusSchema>;

const debtBaseSchema = z.object({
  personName: z.string().min(1).max(120),
  amount: positiveDecimalSchema,
  currency: currencyCodeSchema.default('TRY'),
  direction: debtDirectionSchema,
  description: z.string().max(500).optional(),
  dueDate: isoDateSchema.optional(),
});

/**
 * 💸 Borç/alacak kaydı bütçeye de işlenir (paymentCardId verilirse):
 *  - i_owe (borç aldım)      → oluştururken GELİR (income kart), ödeyince GİDER (expense kart)
 *  - owed_to_me (borç verdim) → oluştururken GİDER (expense kart), tahsil edince GELİR (income kart)
 * İşlem onaylı doğar (para el değiştirdi); moneyAccountId verilirse hesap bakiyesine de yansır.
 */
const debtBudgetLinkSchema = z.object({
  paymentCardId: uuidSchema.optional(),
  moneyAccountId: uuidSchema.optional(),
  date: isoDateSchema.optional(),
});

export const createDebtSchema = debtBaseSchema.merge(debtBudgetLinkSchema);
export type CreateDebtInput = z.infer<typeof createDebtSchema>;

export const updateDebtSchema = debtBaseSchema.partial().extend({
  status: debtStatusSchema.optional(),
});
export type UpdateDebtInput = z.infer<typeof updateDebtSchema>;

export const recordDebtPaymentSchema = z.object({
  amount: positiveDecimalSchema,
  paidAt: isoDateSchema.optional(),
  note: z.string().max(500).optional(),
  // 💸 Ödeme/tahsilat bütçeye işlensin: i_owe → GİDER kartı, owed_to_me → GELİR kartı.
  paymentCardId: uuidSchema.optional(),
  moneyAccountId: uuidSchema.optional(),
});
export type RecordDebtPaymentInput = z.infer<typeof recordDebtPaymentSchema>;
